// extracted by mini-css-extract-plugin
export default {"root":"XQW_h1oxAzmrVPHKTs8a","title":"uY_IcKoNuQiwpTkplaXR","description":"ho4tkEagnQX5MX0RR8Qy","error":"GpI97GDr6RLQzIGDG_eW"};